import { useMutation } from '@tanstack/react-query';
import { 
  regenerateImageFromPost, 
  generateImage,
  ImageRegenerateRequest, 
  ImageRegenerateResponse,
  ImageGenerateRequest,
  ImageGenerateResponse
} from '../services/imageService';

export const useImageRegeneration = () => {
  return useMutation<ImageRegenerateResponse, Error, ImageRegenerateRequest>({
    mutationFn: regenerateImageFromPost,
    onError: (error) => {
      console.error('Image regeneration failed:', error);
    },
  });
};

export const useImageGeneration = () => {
  return useMutation<ImageGenerateResponse, Error, ImageGenerateRequest>({
    mutationFn: generateImage,
    onError: (error) => {
      console.error('Image generation failed:', error);
    },
  });
}; 